import { Link } from "react-router-dom";
import { Clock, User } from "lucide-react";

const fmtDate = (d) => new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });

export const BlogCard = ({ post }) => (
  <article
    className="group bg-card rounded-2xl border border-border overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col"
    data-testid={`blog-card-${post.slug}`}
  >
    <Link to={`/blog/${post.slug}`} className="block focus:outline-none focus-visible:ring-2 focus-visible:ring-ring">
      <div className="aspect-[16/10] overflow-hidden bg-muted">
        <img
          src={post.cover_image}
          alt={post.title}
          loading="lazy"
          width="640"
          height="400"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
    </Link>
    <div className="p-5 flex flex-col flex-1">
      <span className="inline-block self-start text-xs font-semibold text-primary bg-primary/10 rounded-full px-3 py-1">{post.category}</span>
      <h3 className="font-display font-bold text-lg leading-snug mt-3">
        <Link to={`/blog/${post.slug}`} className="hover:text-primary transition-colors">{post.title}</Link>
      </h3>
      <p className="text-sm text-muted-foreground mt-2 line-clamp-2 flex-1">{post.excerpt}</p>
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-muted-foreground mt-4">
        <span className="flex items-center gap-1"><User className="w-3 h-3" aria-hidden="true" />{post.author}</span>
        <span aria-hidden="true">·</span>
        <time dateTime={post.published_at}>{fmtDate(post.published_at)}</time>
        <span aria-hidden="true">·</span>
        <span className="flex items-center gap-1"><Clock className="w-3 h-3" aria-hidden="true" />{post.reading_time} min read</span>
      </div>
      <Link
        to={`/blog/${post.slug}`}
        className="inline-block mt-4 text-sm font-semibold text-primary hover:underline"
        data-testid={`read-more-${post.slug}`}
      >
        Read More →
      </Link>
    </div>
  </article>
);
